import { showNotify } from "vendor/application/disptach";

export const validateDesk = (intent, dispatch) => {
    if (intent.desks?.name === "zendesk_full" && !intent.desks?.info.desk_id) {
      dispatch(showNotify({ message: "no_desk_id_intent", severity: "error" }));
      return false;
    }
    return true;
  };